var _regeneratorRuntime = require("/codebuild/output/src2944701429/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    var n = e();

    for (var r in n) {
      ("object" == typeof exports ? exports : t)[r] = n[r];
    }
  }
}(global, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 11);
  }([function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e) {
    function n(e) {
      return t.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, n(e);
    }

    t.exports = n;
  }, function (t, e, n) {
    var r = n(12),
        o = n(5);

    t.exports = function (t, e) {
      return !e || "object" !== r(e) && "function" != typeof e ? o(t) : e;
    };
  }, function (t, e, n) {
    var r = n(6);

    t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && r(t, e);
    };
  }, function (t, e) {
    function n(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    t.exports = function (t, e, r) {
      return e && n(t.prototype, e), r && n(t, r), t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }, function (t, e) {
    function n(e, r) {
      return t.exports = n = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, n(e, r);
    }

    t.exports = n;
  }, function (t, e) {
    t.exports = require("axios");
  }, function (t, e) {
    t.exports = require("qs");
  }, function (t, e, n) {
    var r = n(1),
        o = n(6),
        i = n(13),
        u = n(14);

    function s(e) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return t.exports = s = function s(t) {
        if (null === t || !i(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== n) {
          if (n.has(t)) return n.get(t);
          n.set(t, e);
        }

        function e() {
          return u(t, arguments, r(this).constructor);
        }

        return e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), o(e, t);
      }, s(e);
    }

    t.exports = s;
  }, function (t, e) {
    t.exports = require("lodash/get");
  }, function (t, e, n) {
    t.exports = n(15);
  }, function (t, e) {
    function n(t) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function r(e) {
      return "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? t.exports = r = function r(t) {
        return n(t);
      } : t.exports = r = function r(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : n(t);
      }, r(e);
    }

    t.exports = r;
  }, function (t, e) {
    t.exports = function (t) {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    };
  }, function (t, e, n) {
    var r = n(6);

    function o(e, n, i) {
      return !function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }() ? t.exports = o = function o(t, e, n) {
        var o = [null];
        o.push.apply(o, e);
        var i = new (Function.bind.apply(t, o))();
        return n && r(i, n.prototype), i;
      } : t.exports = o = Reflect.construct, o.apply(null, arguments);
    }

    t.exports = o;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = {};
    n.r(r), n.d(r, "BasicSpreeError", function () {
      return S;
    }), n.d(r, "ExpandedSpreeError", function () {
      return g;
    }), n.d(r, "MisconfigurationError", function () {
      return E;
    }), n.d(r, "NoResponseError", function () {
      return j;
    }), n.d(r, "SpreeError", function () {
      return R;
    }), n.d(r, "SpreeSDKError", function () {
      return k;
    });
    var o = n(0),
        i = n.n(o),
        u = n(4),
        s = n.n(u),
        c = n(2),
        a = n.n(c),
        f = n(1),
        p = n.n(f),
        l = n(3),
        h = n.n(l);
    var d = "get";
    var v = n(7),
        y = n.n(v),
        m = n(8),
        b = n(5),
        w = n.n(b),
        x = n(9);

    var k = function (t) {
      function e(t) {
        var n;
        return i()(this, e), n = a()(this, p()(e).call(this, t)), Object.setPrototypeOf(w()(n), e.prototype), n;
      }

      return h()(e, t), e;
    }(n.n(x)()(Error)),
        R = function (t) {
      function e(t) {
        var n;
        i()(this, e), n = a()(this, p()(e).call(this, "Spree returned a HTTP ".concat(t.status, " error code"))), Object.setPrototypeOf(w()(n), e.prototype), n.name = "SpreeError";
        var r = Object.assign({}, t);
        return Object.defineProperties(r, {
          config: {
            enumerable: !1
          },
          data: {
            enumerable: !1
          },
          headers: {
            enumerable: !1
          },
          request: {
            enumerable: !1
          }
        }), n.serverResponse = r, n;
      }

      return h()(e, t), e;
    }(k);

    var S = function (t) {
      function e(t, n) {
        var r;
        return i()(this, e), r = a()(this, p()(e).call(this, t)), Object.setPrototypeOf(w()(r), e.prototype), r.name = "BasicSpreeError", r.summary = n, r;
      }

      return h()(e, t), e;
    }(R),
        O = n(10),
        _ = n.n(O);

    var g = function (t) {
      function e(t, n, r) {
        var o;
        return i()(this, e), o = a()(this, p()(e).call(this, t, n)), Object.setPrototypeOf(w()(o), e.prototype), o.name = "ExpandedSpreeError", o.errors = Object.keys(r).reduce(function (t, e) {
          var n = e.split(".");
          var o = n.shift(),
              i = t;

          for (; o;) {
            i[o] || (0 === n.length ? i[o] = r[e] : i[o] = {}), i = i[o], o = n.shift();
          }

          return t;
        }, {}), o;
      }

      return h()(e, t), s()(e, [{
        key: "getErrors",
        value: function value(t) {
          return _()(this.errors, t, null);
        }
      }]), e;
    }(S),
        E = function (t) {
      function e(t) {
        var n;
        return i()(this, e), n = a()(this, p()(e).call(this, "Incorrect request setup: ".concat(t))), Object.setPrototypeOf(w()(n), e.prototype), n.name = "MisconfigurationError", n;
      }

      return h()(e, t), e;
    }(k),
        j = function (t) {
      function e() {
        var t;
        return i()(this, e), t = a()(this, p()(e).call(this, "No response received from Spree")), Object.setPrototypeOf(w()(t), e.prototype), t.name = "NoResponseError", t;
      }

      return h()(e, t), e;
    }(k);

    var P,
        C = {
      success: function success(t) {
        return function (t) {
          return {
            isSuccess: function isSuccess() {
              return !0;
            },
            isFail: function isFail() {
              return !1;
            },
            success: function success() {
              return t;
            },
            fail: function fail() {
              throw new Error("Cannot call fail() on success.");
            }
          };
        }(t);
      },
      fail: function fail(t) {
        return function (t) {
          return {
            isSuccess: function isSuccess() {
              return !1;
            },
            isFail: function isFail() {
              return !0;
            },
            success: function success() {
              throw new Error("Cannot call success() on fail.");
            },
            fail: function fail() {
              return t;
            }
          };
        }(t);
      }
    };
    !function (t) {
      t[t.BASIC = 0] = "BASIC", t[t.FULL = 1] = "FULL", t[t.LIMITED = 2] = "LIMITED";
    }(P || (P = {}));

    var T = function T(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var I = function () {
      function t(e) {
        i()(this, t), this.host = e || process.env.SPREE_HOST || "http://localhost:3000/", this.axios = y.a.create({
          baseURL: this.host,
          headers: {
            "Content-Type": "application/json"
          },
          paramsSerializer: function paramsSerializer(t) {
            return m.stringify(t, {
              arrayFormat: "brackets"
            });
          }
        });
      }

      return s()(t, [{
        key: "spreeResponse",
        value: function value(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          return T(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            var _o, _i, _u;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _i = this.axios[t], _u = this.spreeOrderHeaders(n);

                    if (!(t === d || "delete" === t)) {
                      _context.next = 8;
                      break;
                    }

                    _context.next = 5;
                    return _i(e, {
                      params: r,
                      headers: _u
                    });

                  case 5:
                    _context.t0 = _context.sent;
                    _context.next = 11;
                    break;

                  case 8:
                    _context.next = 10;
                    return _i(e, r, {
                      headers: _u
                    });

                  case 10:
                    _context.t0 = _context.sent;

                  case 11:
                    _o = _context.t0;
                    return _context.abrupt("return", C.success(_o.data));

                  case 15:
                    _context.prev = 15;
                    _context.t1 = _context["catch"](0);
                    return _context.abrupt("return", C.fail(this.processError(_context.t1)));

                  case 18:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this, [[0, 15]]);
          }));
        }
      }, {
        key: "classifyError",
        value: function value(t) {
          var _t$response$data = t.response.data,
              e = _t$response$data.error,
              n = _t$response$data.errors;
          return "string" == typeof e ? "object" == typeof n ? P.FULL : P.BASIC : P.LIMITED;
        }
      }, {
        key: "processError",
        value: function value(t) {
          return t.response ? this.processSpreeError(t) : t.request ? new j() : new E(t.message);
        }
      }, {
        key: "processSpreeError",
        value: function value(t) {
          var _t$response$data2 = t.response.data,
              e = _t$response$data2.error,
              n = _t$response$data2.errors,
              r = this.classifyError(t);
          return r === P.FULL ? new g(t.response, e, n) : r === P.BASIC ? new S(t.response, e) : new R(t.response);
        }
      }, {
        key: "spreeOrderHeaders",
        value: function value(t) {
          var e = {};
          return t.orderToken && (e["X-Spree-Order-Token"] = t.orderToken), t.bearerToken && (e.Authorization = "Bearer ".concat(t.bearerToken)), e;
        }
      }]), t;
    }();

    var L = function L() {
      return "api/v2/storefront/products";
    },
        M = function M(t) {
      return "api/v2/storefront/products/".concat(t);
    },
        $ = function $() {
      return "api/v2/storefront/taxons";
    },
        F = function F(t) {
      return "api/v2/storefront/taxons/".concat(t);
    },
        q = function q() {
      return "api/v2/storefront/countries";
    },
        B = function B(t) {
      return "api/v2/storefront/countries/".concat(t);
    },
        D = function D() {
      return "api/v2/storefront/cart";
    },
        U = function U() {
      return "api/v2/storefront/cart/add_item";
    },
        A = function A(t) {
      return "api/v2/storefront/cart/remove_line_item/".concat(t);
    },
        H = function H() {
      return "api/v2/storefront/cart/empty";
    },
        N = function N() {
      return "api/v2/storefront/cart/set_quantity";
    },
        z = function z() {
      return "api/v2/storefront/cart/apply_coupon_code";
    },
        K = function K(t) {
      return "api/v2/storefront/cart/remove_coupon_code/".concat(t);
    },
        Q = function Q() {
      return "api/v2/storefront/cart/estimate_shipping_rates";
    },
        X = function X() {
      return "api/v2/storefront/checkout";
    },
        G = function G() {
      return "api/v2/storefront/checkout/next";
    },
        J = function J() {
      return "api/v2/storefront/checkout/advance";
    },
        V = function V() {
      return "api/v2/storefront/checkout/complete";
    },
        W = function W() {
      return "api/v2/storefront/checkout/add_store_credit";
    },
        Y = function Y() {
      return "api/v2/storefront/checkout/remove_store_credit";
    },
        Z = function Z() {
      return "api/v2/storefront/checkout/payment_methods";
    },
        tt = function tt() {
      return "api/v2/storefront/checkout/shipping_rates";
    },
        et = function et() {
      return "spree_oauth/token";
    },
        nt = function nt() {
      return "api/v2/storefront/account";
    },
        rt = function rt() {
      return "api/v2/storefront/account/credit_cards";
    },
        ot = function ot() {
      return "api/v2/storefront/account/credit_cards/default";
    },
        it = function it() {
      return "api/v2/storefront/account/orders";
    },
        ut = function ut(t) {
      return "api/v2/storefront/account/orders/".concat(t);
    },
        st = function st(t) {
      return "api/v2/storefront/order_status/".concat(t);
    };

    var ct = function ct(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var at = function (t) {
      function e() {
        return i()(this, e), a()(this, p()(e).apply(this, arguments));
      }

      return h()(e, t), s()(e, [{
        key: "accountInfo",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return ct(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return this.spreeResponse(d, nt(), t, e);

                  case 2:
                    return _context2.abrupt("return", _context2.sent);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));
        }
      }, {
        key: "creditCardsList",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return ct(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return this.spreeResponse(d, rt(), t, e);

                  case 2:
                    return _context3.abrupt("return", _context3.sent);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));
        }
      }, {
        key: "defaultCreditCard",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return ct(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4() {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return this.spreeResponse(d, ot(), t, e);

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));
        }
      }, {
        key: "completedOrdersList",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return ct(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee5() {
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return this.spreeResponse(d, it(), t, e);

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          }));
        }
      }, {
        key: "completedOrder",
        value: function value(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return ct(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee6() {
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return this.spreeResponse(d, ut(e), t, n);

                  case 2:
                    return _context6.abrupt("return", _context6.sent);

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, this);
          }));
        }
      }]), e;
    }(I);

    var ft = function ft(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var pt = function (t) {
      function e() {
        return i()(this, e), a()(this, p()(e).apply(this, arguments));
      }

      return h()(e, t), s()(e, [{
        key: "getToken",
        value: function value(t) {
          return ft(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee7() {
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return this.spreeResponse("post", et(), {}, function (_ref) {
                      var t = _ref.username,
                          e = _ref.password;
                      return {
                        username: t,
                        password: e,
                        grant_type: "password"
                      };
                    }(t));

                  case 2:
                    return _context7.abrupt("return", _context7.sent);

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, this);
          }));
        }
      }, {
        key: "refreshToken",
        value: function value(t) {
          return ft(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee8() {
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return this.spreeResponse("post", et(), {}, function (_ref2) {
                      var t = _ref2.refresh_token;
                      return {
                        refresh_token: t,
                        grant_type: "refresh_token"
                      };
                    }(t));

                  case 2:
                    return _context8.abrupt("return", _context8.sent);

                  case 3:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8, this);
          }));
        }
      }]), e;
    }(I);

    var lt = function lt(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var ht = function (t) {
      function e() {
        return i()(this, e), a()(this, p()(e).apply(this, arguments));
      }

      return h()(e, t), s()(e, [{
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee9() {
            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return this.spreeResponse(d, D(), t, e);

                  case 2:
                    return _context9.abrupt("return", _context9.sent);

                  case 3:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9, this);
          }));
        }
      }, {
        key: "create",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee10() {
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return this.spreeResponse("post", D(), t, e);

                  case 2:
                    return _context10.abrupt("return", _context10.sent);

                  case 3:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10, this);
          }));
        }
      }, {
        key: "addItem",
        value: function value(t, e) {
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee11() {
            return _regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.next = 2;
                    return this.spreeResponse("post", U(), t, e);

                  case 2:
                    return _context11.abrupt("return", _context11.sent);

                  case 3:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11, this);
          }));
        }
      }, {
        key: "removeItem",
        value: function value(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee12() {
            return _regeneratorRuntime.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return this.spreeResponse("delete", A(e), t, n);

                  case 2:
                    return _context12.abrupt("return", _context12.sent);

                  case 3:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12, this);
          }));
        }
      }, {
        key: "emptyCart",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee13() {
            return _regeneratorRuntime.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return this.spreeResponse("patch", H(), t, e);

                  case 2:
                    return _context13.abrupt("return", _context13.sent);

                  case 3:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee13, this);
          }));
        }
      }, {
        key: "setQuantity",
        value: function value(t, e) {
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee14() {
            return _regeneratorRuntime.wrap(function _callee14$(_context14) {
              while (1) {
                switch (_context14.prev = _context14.next) {
                  case 0:
                    _context14.next = 2;
                    return this.spreeResponse("patch", N(), t, e);

                  case 2:
                    return _context14.abrupt("return", _context14.sent);

                  case 3:
                  case "end":
                    return _context14.stop();
                }
              }
            }, _callee14, this);
          }));
        }
      }, {
        key: "applyCouponCode",
        value: function value(t, e) {
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee15() {
            return _regeneratorRuntime.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    _context15.next = 2;
                    return this.spreeResponse("patch", z(), t, e);

                  case 2:
                    return _context15.abrupt("return", _context15.sent);

                  case 3:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee15, this);
          }));
        }
      }, {
        key: "removeCouponCode",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee16() {
            var r;
            return _regeneratorRuntime.wrap(function _callee16$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                    r = "";
                    r = K(null !== e ? e : "");
                    _context16.next = 4;
                    return this.spreeResponse("delete", r, t, n);

                  case 4:
                    return _context16.abrupt("return", _context16.sent);

                  case 5:
                  case "end":
                    return _context16.stop();
                }
              }
            }, _callee16, this);
          }));
        }
      }, {
        key: "estimateShippingMethods",
        value: function value(t, e) {
          return lt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee17() {
            return _regeneratorRuntime.wrap(function _callee17$(_context17) {
              while (1) {
                switch (_context17.prev = _context17.next) {
                  case 0:
                    _context17.next = 2;
                    return this.spreeResponse(d, Q(), t, e);

                  case 2:
                    return _context17.abrupt("return", _context17.sent);

                  case 3:
                  case "end":
                    return _context17.stop();
                }
              }
            }, _callee17, this);
          }));
        }
      }]), e;
    }(I);

    var dt = function dt(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var vt = function (t) {
      function e() {
        return i()(this, e), a()(this, p()(e).apply(this, arguments));
      }

      return h()(e, t), s()(e, [{
        key: "orderNext",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return dt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee18() {
            return _regeneratorRuntime.wrap(function _callee18$(_context18) {
              while (1) {
                switch (_context18.prev = _context18.next) {
                  case 0:
                    _context18.next = 2;
                    return this.spreeResponse("patch", G(), t, e);

                  case 2:
                    return _context18.abrupt("return", _context18.sent);

                  case 3:
                  case "end":
                    return _context18.stop();
                }
              }
            }, _callee18, this);
          }));
        }
      }, {
        key: "orderUpdate",
        value: function value(t, e) {
          return dt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee19() {
            return _regeneratorRuntime.wrap(function _callee19$(_context19) {
              while (1) {
                switch (_context19.prev = _context19.next) {
                  case 0:
                    _context19.next = 2;
                    return this.spreeResponse("patch", X(), t, e);

                  case 2:
                    return _context19.abrupt("return", _context19.sent);

                  case 3:
                  case "end":
                    return _context19.stop();
                }
              }
            }, _callee19, this);
          }));
        }
      }, {
        key: "advance",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return dt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee20() {
            return _regeneratorRuntime.wrap(function _callee20$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    _context20.next = 2;
                    return this.spreeResponse("patch", J(), t, e);

                  case 2:
                    return _context20.abrupt("return", _context20.sent);

                  case 3:
                  case "end":
                    return _context20.stop();
                }
              }
            }, _callee20, this);
          }));
        }
      }, {
        key: "complete",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return dt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee21() {
            return _regeneratorRuntime.wrap(function _callee21$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    _context21.next = 2;
                    return this.spreeResponse("patch", V(), t, e);

                  case 2:
                    return _context21.abrupt("return", _context21.sent);

                  case 3:
                  case "end":
                    return _context21.stop();
                }
              }
            }, _callee21, this);
          }));
        }
      }, {
        key: "addStoreCredits",
        value: function value(t, e) {
          return dt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee22() {
            return _regeneratorRuntime.wrap(function _callee22$(_context22) {
              while (1) {
                switch (_context22.prev = _context22.next) {
                  case 0:
                    _context22.next = 2;
                    return this.spreeResponse("post", W(), t, e);

                  case 2:
                    return _context22.abrupt("return", _context22.sent);

                  case 3:
                  case "end":
                    return _context22.stop();
                }
              }
            }, _callee22, this);
          }));
        }
      }, {
        key: "removeStoreCredits",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return dt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee23() {
            return _regeneratorRuntime.wrap(function _callee23$(_context23) {
              while (1) {
                switch (_context23.prev = _context23.next) {
                  case 0:
                    _context23.next = 2;
                    return this.spreeResponse("post", Y(), t, e);

                  case 2:
                    return _context23.abrupt("return", _context23.sent);

                  case 3:
                  case "end":
                    return _context23.stop();
                }
              }
            }, _callee23, this);
          }));
        }
      }, {
        key: "paymentMethods",
        value: function value(t) {
          return dt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee24() {
            return _regeneratorRuntime.wrap(function _callee24$(_context24) {
              while (1) {
                switch (_context24.prev = _context24.next) {
                  case 0:
                    _context24.next = 2;
                    return this.spreeResponse(d, Z(), t);

                  case 2:
                    return _context24.abrupt("return", _context24.sent);

                  case 3:
                  case "end":
                    return _context24.stop();
                }
              }
            }, _callee24, this);
          }));
        }
      }, {
        key: "shippingMethods",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return dt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee25() {
            return _regeneratorRuntime.wrap(function _callee25$(_context25) {
              while (1) {
                switch (_context25.prev = _context25.next) {
                  case 0:
                    _context25.next = 2;
                    return this.spreeResponse(d, tt(), t, e);

                  case 2:
                    return _context25.abrupt("return", _context25.sent);

                  case 3:
                  case "end":
                    return _context25.stop();
                }
              }
            }, _callee25, this);
          }));
        }
      }]), e;
    }(I);

    var yt = function yt(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var mt = function (t) {
      function e() {
        return i()(this, e), a()(this, p()(e).apply(this, arguments));
      }

      return h()(e, t), s()(e, [{
        key: "list",
        value: function value() {
          return yt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee26() {
            return _regeneratorRuntime.wrap(function _callee26$(_context26) {
              while (1) {
                switch (_context26.prev = _context26.next) {
                  case 0:
                    _context26.next = 2;
                    return this.spreeResponse(d, q());

                  case 2:
                    return _context26.abrupt("return", _context26.sent);

                  case 3:
                  case "end":
                    return _context26.stop();
                }
              }
            }, _callee26, this);
          }));
        }
      }, {
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return yt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee27() {
            return _regeneratorRuntime.wrap(function _callee27$(_context27) {
              while (1) {
                switch (_context27.prev = _context27.next) {
                  case 0:
                    _context27.next = 2;
                    return this.spreeResponse(d, B(t), {}, e);

                  case 2:
                    return _context27.abrupt("return", _context27.sent);

                  case 3:
                  case "end":
                    return _context27.stop();
                }
              }
            }, _callee27, this);
          }));
        }
      }]), e;
    }(I);

    var bt = function bt(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var wt = function (t) {
      function e() {
        return i()(this, e), a()(this, p()(e).apply(this, arguments));
      }

      return h()(e, t), s()(e, [{
        key: "status",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return bt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee28() {
            return _regeneratorRuntime.wrap(function _callee28$(_context28) {
              while (1) {
                switch (_context28.prev = _context28.next) {
                  case 0:
                    _context28.next = 2;
                    return this.spreeResponse(d, st(t), {}, e);

                  case 2:
                    return _context28.abrupt("return", _context28.sent);

                  case 3:
                  case "end":
                    return _context28.stop();
                }
              }
            }, _callee28, this);
          }));
        }
      }]), e;
    }(I);

    var xt = function xt(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var kt = function (t) {
      function e() {
        return i()(this, e), a()(this, p()(e).apply(this, arguments));
      }

      return h()(e, t), s()(e, [{
        key: "list",
        value: function value() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return xt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee29() {
            return _regeneratorRuntime.wrap(function _callee29$(_context29) {
              while (1) {
                switch (_context29.prev = _context29.next) {
                  case 0:
                    _context29.next = 2;
                    return this.spreeResponse(d, L(), {}, t);

                  case 2:
                    return _context29.abrupt("return", _context29.sent);

                  case 3:
                  case "end":
                    return _context29.stop();
                }
              }
            }, _callee29, this);
          }));
        }
      }, {
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return xt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee30() {
            return _regeneratorRuntime.wrap(function _callee30$(_context30) {
              while (1) {
                switch (_context30.prev = _context30.next) {
                  case 0:
                    _context30.next = 2;
                    return this.spreeResponse(d, M(t), {}, e);

                  case 2:
                    return _context30.abrupt("return", _context30.sent);

                  case 3:
                  case "end":
                    return _context30.stop();
                }
              }
            }, _callee30, this);
          }));
        }
      }]), e;
    }(I);

    var Rt = function Rt(t, e, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(t) {
          try {
            c(r.next(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          try {
            c(r.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function c(t) {
          t.done ? o(t.value) : new n(function (e) {
            e(t.value);
          }).then(u, s);
        }

        c((r = r.apply(t, e || [])).next());
      });
    };

    var St = function (t) {
      function e() {
        return i()(this, e), a()(this, p()(e).apply(this, arguments));
      }

      return h()(e, t), s()(e, [{
        key: "list",
        value: function value() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return Rt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee31() {
            return _regeneratorRuntime.wrap(function _callee31$(_context31) {
              while (1) {
                switch (_context31.prev = _context31.next) {
                  case 0:
                    _context31.next = 2;
                    return this.spreeResponse(d, $(), {}, t);

                  case 2:
                    return _context31.abrupt("return", _context31.sent);

                  case 3:
                  case "end":
                    return _context31.stop();
                }
              }
            }, _callee31, this);
          }));
        }
      }, {
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return Rt(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee32() {
            return _regeneratorRuntime.wrap(function _callee32$(_context32) {
              while (1) {
                switch (_context32.prev = _context32.next) {
                  case 0:
                    _context32.next = 2;
                    return this.spreeResponse(d, F(t), {}, e);

                  case 2:
                    return _context32.abrupt("return", _context32.sent);

                  case 3:
                  case "end":
                    return _context32.stop();
                }
              }
            }, _callee32, this);
          }));
        }
      }]), e;
    }(I);

    var Ot = function () {
      function t() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        i()(this, t), this.host = e.host || null, this.addEndpoints();
      }

      return s()(t, [{
        key: "addEndpoints",
        value: function value() {
          this.account = new at(this.host), this.authentication = new pt(this.host), this.cart = new ht(this.host), this.checkout = new vt(this.host), this.countries = new mt(this.host), this.order = new wt(this.host), this.products = new kt(this.host), this.taxons = new St(this.host);
        }
      }]), t;
    }();

    n.d(e, "makeClient", function () {
      return _t;
    }), n.d(e, "Client", function () {
      return Ot;
    }), n.d(e, "Http", function () {
      return I;
    }), n.d(e, "Result", function () {
      return C;
    }), n.d(e, "errors", function () {
      return r;
    });

    var _t = function _t() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Ot(t);
    };
  }]);
});